import Jumbotron from './jumbotron';
export default Jumbotron;
